import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import Close from "@mui/icons-material/Close";
// Limitless imports
import { useTranslation } from "@limitless/common/hooks/translation/TranslationContext";
import CustomerButton from "../../customer-button/CustomerButton";
import { nextButtonStyle } from "./ResolutionScreen";
import { ratingStyles } from "./CSATScreen";
import RenderQuestion from "./RenderQuestion";
const useStyles = makeStyles(theme => ({
  ...ratingStyles(theme),
  npsContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    padding: "24px 16px 16px 16px"
  },
  text: {
    fontSize: "8px",
    textAlign: "center",
    marginBottom: "15px"
  },
  closeButtonContainer: {
    position: "fixed",
    width: "100%",
    textAlign: "end"
  },
  closeButton: {
    padding: 3,
    marginRight: 8,
    "&:hover": {
      backgroundColor: "transparent"
    }
  },
  closeIcon: {
    color: "#3e7aff",
    height: 20
  }
}));
const Questions = [{
  name: "expertFeedback",
  label: "Has the request you contacted us about been fulfilled?",
  options: [{
    label: "Yes",
    value: true
  }, {
    label: "No",
    value: false
  }, {
    label: "Not yet, awaiting follow up",
    value: ""
  }]
}, {
  name: "generalFeedback",
  label: "How many times did you have to contact us about the request before it was fulfilled?",
  options: [{
    label: "Once",
    value: "Once"
  }, {
    label: "More than once",
    value: "More than once"
  }]
}, {
  name: "feedback",
  label: "Do you have 4-5 minutes for more questions on your overall experience?",
  options: [{
    label: "Yes",
    value: "Yes"
  }, {
    label: "No",
    value: "No"
  }]
}];
const FurtherContactScreen = ({
  message,
  onSubmitResoluationContact,
  onSubmitTestimonial,
  onCancelDialog
}) => {
  var _message$custClientRe, _message$custClientRe2, _message$custClientRe3;
  const classes = useStyles();
  const [contactState, setContactState] = React.useState({
    expertFeedback: (_message$custClientRe = message.custClientReview) === null || _message$custClientRe === void 0 ? void 0 : _message$custClientRe.expertFeedback,
    generalFeedback: (_message$custClientRe2 = message.custClientReview) === null || _message$custClientRe2 === void 0 ? void 0 : _message$custClientRe2.generalFeedback,
    feedback: (_message$custClientRe3 = message.custClientReview) === null || _message$custClientRe3 === void 0 ? void 0 : _message$custClientRe3.feedback
  });
  const [testimonial, setTestimonialText] = React.useState(message === null || message === void 0 ? void 0 : message.custTestimonial);
  const {
    t
  } = useTranslation();
  const isResolved = React.useMemo(() => {
    return contactState.expertFeedback === "true" || contactState.expertFeedback === true;
  }, [contactState.expertFeedback]);
  const updateState = state => {
    setContactState({
      ...contactState,
      ...state
    });
  };
  const getQuestionArray = React.useMemo(() => {
    return Questions.map(option => ({
      ...option,
      value: contactState[option.name] === null ? "" : contactState[option.name],
      visible: option.name === "generalFeedback" ? isResolved : true,
      onChange: event => {
        updateState({
          [option.name]: event.target.value
        });
      }
    }));
  }, [contactState]);
  const handleSubmit = () => {
    var _contactState$expertF;
    const expertFeedback = ((_contactState$expertF = contactState.expertFeedback) === null || _contactState$expertF === void 0 ? void 0 : _contactState$expertF.length) === 0 ? null : isResolved.toString();
    onSubmitTestimonial(testimonial);
    onSubmitResoluationContact({
      ...contactState,
      expertFeedback,
      generalFeedback: isResolved ? contactState.generalFeedback : ""
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.closeButtonContainer
  }, /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": t("Close NPS"),
    onClick: () => onCancelDialog(true),
    component: "div",
    id: "closeNPSFeedback",
    className: classes.closeButton
  }, /*#__PURE__*/React.createElement(Close, {
    className: classes.closeIcon
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.npsContainer
  }, getQuestionArray.filter(question => question.visible).map((question, index) => {
    return /*#__PURE__*/React.createElement(RenderQuestion, {
      key: index,
      index: index + 1,
      value: question.value,
      label: question.label,
      name: question.name,
      onChange: question.onChange,
      options: question.options
    });
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2"
  }, "Any additional comments?"), /*#__PURE__*/React.createElement(TextField, {
    classes: {
      root: classes.textField
    },
    id: "testimonial",
    variant: "outlined",
    InputProps: {
      classes: {
        notchedOutline: classes.notchedOutline,
        focused: classes.focused,
        root: classes.root
      }
    },
    value: testimonial,
    onChange: event => setTestimonialText(event.target.value)
  }), /*#__PURE__*/React.createElement(Typography, {
    className: classes.text
  }, t("At times we recontact people to better understand their response. By clicking submit, you acknowledge our permission to follow up.")), /*#__PURE__*/React.createElement("div", {
    className: classes.nextButtonContainer
  }, /*#__PURE__*/React.createElement(CustomerButton, {
    onClick: handleSubmit,
    component: "div",
    style: nextButtonStyle,
    id: "nextButtonofexpertfeedback"
  }, t("Submit")))));
};
FurtherContactScreen.propTypes = {
  message: PropTypes.object.isRequired,
  onSubmitResoluationContact: PropTypes.func.isRequired,
  onSubmitTestimonial: PropTypes.func.isRequired,
  onCancelDialog: PropTypes.func.isRequired
};
export default FurtherContactScreen;